export const theme = {
  colors: {
    primary: "#7aa383",
    secondary: "#F2F2F2",
    tertiary: "#F2F2F2",
  },
};
